module.exports = __webpack_public_path__ + "04_short_gold.67c4fa6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/04_short_gold.png
// module id = 1F6A
// module chunks = 0